// Self-hosted, OFL-licensed brand faces (see docs/design-system/09-BRAND-ASSET-REGISTER.md).
import '@fontsource-variable/inter-tight';
import '@fontsource-variable/schibsted-grotesk';
import '@fontsource-variable/source-sans-3';
import '@fontsource-variable/nunito';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import './styles/tokens.css';
import './styles/global.css';
import './styles/brand-scenes.css';
import { PresentationController } from './core/PresentationController';
import { buildPresentation, resolveConfig } from './presentation/registry';

const app = document.querySelector<HTMLDivElement>('#app');

if (!app) {
  throw new Error('Missing #app root element');
}

// The rehearsal override (?modules=…) is a development convenience; production always uses config.ts.
const config = resolveConfig(import.meta.env.DEV ? window.location.search : '');
const presentation = new PresentationController(app, buildPresentation(config));
presentation.start();
